<template>
  <div>
    <v-tabs
      color="black"
    >
      <v-tabs-slider color="darkGreen"></v-tabs-slider>
      <v-tab class="font-readex font-weight-bold">
        <v-icon class="mr-3">mdi-history</v-icon>
        Historie/Zaplaceno
      </v-tab>
      <v-tab-item>
        <v-alert color="error" v-if="serverError">Chyba serveru</v-alert>
        <v-progress-circular
          v-if="loading"
          indeterminate
          :size="70"
          color="darkGreen"
        ></v-progress-circular>
        <v-container class="container" fluid v-else>
          <v-row justify="center">
            <v-col cols="12">
              <v-data-table
                :headers="historyOrdersHeaders"
                :items="historyOrders"
                item-key="subId"
                single-expand
                show-expand
                class="lightYellow stripedDT elevation-1"
              >
                <template v-slot:item.localDate="{ item }">
                  <span>{{getLocalizedDate(item.date)}}</span>
                </template>
                <template v-slot:item.localDay="{ item }">
                  <span>{{getLocalizedWeekDay(item.date)}}</span>
                </template>
                <template v-slot:item.selectedTimes="{ item }">
                  <span>{{getSelectedTimesStr(item.date, item.items)}}</span>
                </template>
                <template v-slot:item.priceCol="{ item }">
                  <span style="color: var(--v-darkGreen-base)" class="font-weight-bold">{{item.dayPrice + ' Kč'}}</span>
                </template>
                <template v-slot:item.stateCol="{ item }">
                  <span style="color:red;" v-if="item.state === 'Nezaplacená' || item.state === 'Stornovaná'" class="font-weight-bold">{{item.state}}</span>
                  <span style="color:green;" v-else-if="item.state === 'Dokončená'" class="font-weight-bold">{{item.state}}</span>
                  <span v-else class="font-weight-bold">{{item.state}}</span>
                </template>
                <template v-slot:item.payLink="{ item }">
                  <v-btn
                    v-if="item.state ==='Nezaplacená'"
                    @click="payOrder(item.id)"
                    class="btn btn-green-gradient"
                    dark
                  >Zaplatit
                  </v-btn>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="py-5">
                          <v-btn
                            v-if="item.state ==='Nezaplacená'"
                            @click="payOrder(item.id)"
                          >Zaplatit
                          </v-btn>
                    <v-container>
                      <v-row>
                        <v-col>
                          <div class="ml-2">
                            Způsob dodání: {{item.deliveryType}}
                          </div>
                          <div class="ml-2">
                            Typ balení: {{item.customPackaging ? 'Vlastní nádoba' : 'Standardní balení'}}
                          </div>
                        </v-col>
                        <v-col>
                          <div class="ml-2">
                            Způsob platby: {{item.paymentType}}
                          </div>
                          <div class="ml-2">
                            Objednávka pro uživatele: {{item.order ? 'Ano' : 'Ne'}}
                          </div>
                          <div class="ml-2" v-if="item.boarders.length">
                            Strávníci: {{item.boarders.map(boarder => `${boarder.firstName} ${boarder.lastName}`).join(', ')}}
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div>Poznámka: {{item.description}}</div>
                        </v-col>
                      </v-row>
                      <div class="d-block">
                        <div><b>Dodací adresa:</b></div>
                        <div>{{item.deliveryStreet}} {{item.deliveryStreetNumber}}</div>
                        <div>{{item.deliveryCity}} {{item.deliveryZip}}</div>
                      </div>
                    </v-container>
                          <div
                            v-for="(time, i) in item.items"
                            :key="i">
                            <v-data-table
                              v-if="time.length"
                              :headers="historyHeaders"
                              :items="time"
                              :expanded="expanded"
                              item-key="id"
                              show-expand
                              class="elevation-0 item-table"
                              hide-default-footer
                              disable-sort
                              dense
                            >
                              <template v-slot:top>
                                <v-toolbar flat dense>
                                  <v-toolbar-title>{{timeTypes.length ? timeTypes[i].name : ''}}</v-toolbar-title>
                                  <v-spacer></v-spacer>
                                </v-toolbar>
                              </template>
                              <template v-slot:expanded-item="{ headers, item }">
                                <td
                                  :colspan="headers.length"
                                  v-if="item.type === 'App\\Menu'"
                                >
                                  <div v-for="(menuItem, index) in item.drinks.concat(item.foods)" :key="index">
                                    {{menuItem.name}}
                                  </div>
                                </td>
                                <td
                                  :colspan="headers.length"
                                  v-else
                                >{{item.name}}</td>
                              </template>
                            </v-data-table>
                          </div>
                      </td>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab class="font-readex font-weight-bold">
        <v-icon class="mr-3">mdi-truck-delivery</v-icon>
        Nadcházející
      </v-tab>
      <v-tab-item>
        <v-alert color="error" v-if="serverError">Chyba serveru</v-alert>
        <v-alert color="error" v-if="deleteError">Objednávku se nepodařilo smazat</v-alert>
        <v-dialog v-model="editDialog">
          <v-card>
            <OrderForm
              v-if="editDialog"
              :order="editedItem"
              @order-finished="getOrders"
              @order-canceled="editDialog = false"
            ></OrderForm>
          </v-card>
        </v-dialog>
        <div class="text-center" v-if="loading">
          <v-progress-circular
            indeterminate
            :size="70"
            color="darkGreen"
            class="text-center"
          ></v-progress-circular>
        </div>
        <v-container class="container" fluid v-else>
          <v-row justify="center">
            <v-col cols="12">
              <v-expansion-panels multiple v-if="upcomingOrders.length">
                <v-expansion-panel
                  v-for="(order, index) in upcomingOrders"
                  :key="index"
                  style="background-color: var(--v-lightYellow-base)"
                >
                  <v-expansion-panel-header
                    :class="{'red darken-1': order.state ==='Nezaplacená'}">
                    <tr>
                      <th class="cart-heading">{{getLocalizedWeekDay(order.date)}}</th>
                      <th class="cart-heading">{{getLocalizedDate(order.date)}}</th>
                      <td class="cart-heading">{{getSelectedTimesStr(order.date, order.items)}}</td>
                      <td class="cart-heading text-right">Objednávka č. {{order.orderId}}</td>
                      <td class="cart-heading">{{order.dayPrice}} Kč</td>
                      <td >
                        <v-icon v-if="order.paymentTypeId !== 5"
                          @click.stop="editOrder(order)"
                        >
                          mdi-pencil
                        </v-icon>
                        <div v-if="order.state == 'Nezaplacená'">
                          Zaplatit můžete v kartě historie
                        </div>
                      </td>
                      <td>
                        <v-icon v-if="order.paymentTypeId !== 5 || (order.paymentTypeId === 5 && order.state === 'Čekající')"
                          @click.stop="deleteOrder(order.orderId, order.date, order)"
                        >
                          mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-container>
                      <v-row>
                        <v-col>
                          <div class="ml-2">
                            Způsob dodání: {{order.deliveryType}}
                          </div>
                          <div class="ml-2">
                            Typ balení: {{order.customPackaging ? 'Vlastní nádoba' : 'Standardní balení'}}
                          </div>
                        </v-col>
                        <v-col>
                          <div class="ml-2">
                            Způsob platby: {{order.paymentType}}
                          </div>
                          <div class="ml-2">
                            Objednávka pro uživatele: {{order.order ? 'Ano' : 'Ne'}}
                          </div>
                          <div class="ml-2" v-if="order.boarders.length">
                            Strávníci: {{order.boarders.map(boarder => `${boarder.firstName} ${boarder.lastName}`).join(', ')}}
                          </div>
                        </v-col>
                        <v-col cols="12"><div class="ml-2">Stav: {{order.state}}</div></v-col>
                        <v-col cols="12"><div class="ml-2">Poznámka: {{order.description}}</div></v-col>
                      </v-row>
                      <div class="d-block">
                        <div><b>Dodací adresa:</b></div>
                        <div>{{order.deliveryStreet}} {{order.deliveryStreetNumber}}</div>
                        <div>{{order.deliveryCity}} {{order.deliveryZip}}</div>
                      </div>
                    </v-container>
                    <div
                      v-for="(time, i) in order.items"
                      :key="i">
                      <v-data-table
                        v-if="time.length"
                        :headers="historyHeaders"
                        :items="time"
                        :expanded="expanded"
                        item-key="id"
                        show-expand
                        class="elevation-1 order-table"
                        hide-default-footer
                        disable-sort
                        dense
                      >
                        <template v-slot:top>
                          <v-toolbar flat dense>
                            <v-toolbar-title>{{timeTypes.length ? timeTypes[i].name : ''}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                          <td
                            :colspan="headers.length"
                            v-if="item.type === 'App\\Menu'"
                          >
                            <div
                              v-for="(menuItem, index) in item.drinks.concat(item.foods)" :key="index"
                            >{{menuItem.name}}</div>
                          </td>
                          <td
                            :colspan="headers.length"
                            v-else
                          >{{item.name}}</td>
                        </template>
                      </v-data-table>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-card v-else>
                <v-card-text>Žádné objednávky k zobrazení.</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab class="font-readex font-weight-bold">
        <v-icon class="mr-3">mdi-cash</v-icon>
        Transakce
      </v-tab>
      <v-tab-item>
        <v-data-table
          :headers="transactionsHeaders"
          :items="transactions"
          hide-default-footer
          class="lightYellow stripedDT"
          :items-per-page="-1"
        >

          <template v-slot:item.price="{ item }">
            <div :class="getPaymentTypeColor(item.paymentTypeId)">{{ item.price }}</div>
          </template>
          <template v-slot:item.invoice="{ item }"
          >
            <v-icon
              v-if="item.invoice"
              @click="showInvoice(item)"
              color="darkGreen"
            >fa-file-pdf</v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import OrderForm from '../../components/forms/order/OrderForm'
export default {
  name: 'OrderHistory',
  components: { OrderForm },
  data () {
    return {
      editDialog: false,
      editedItem: {},
      expanded: [],
      loading: true,
      serverError: false,
      deleteError: false,
      timeTypes: [],
      transactionsHeaders: [
        {
          text: 'ID',
          align: 'start',
          sortable: true,
          value: 'id',
          width: 75
        },
        {
          text: 'Typ transakce',
          sortable: false,
          value: 'type'
        },
        {
          text: 'Číslo objednávky',
          value: 'orderId'
        },
        {
          text: 'Datum',
          value: 'date'
        },
        {
          text: 'Částka',
          value: 'price'
        },
        {
          text: 'Stav',
          value: 'status'
        },
        {
          text: 'Faktura',
          value: 'invoice'
        }
      ],
      diets: [],
      transactions: [],
      historyHeaders: [
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'name',
          width: 300
        },
        { text: 'Alergeny', value: 'alergensStr' },
        { text: 'Kalorie', value: 'calories' },
        { text: 'Cena za ks', value: 'price' },
        { text: '', value: 'data-table-expand' },
        { text: 'Množství', value: 'totalQuantity' }
      ],
      historyOrdersHeaders: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'id',
          width: 300
        },
        { text: 'Datum', value: 'localDate' },
        { text: 'Den', value: 'localDay' },
        { text: 'Jídla', value: 'selectedTimes' },
        { text: 'Částka', value: 'priceCol' },
        { text: 'Cena za kus obalu', value: 'packagingPrice' },
        { text: 'Stav', value: 'stateCol' },
        { text: 'Doplatit', value: 'payLink' },
        { text: 'Více', value: 'data-table-expand' }
      ],
      historyOrders: [],
      upcomingOrders: []
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  methods: {
    initialize () {
      this.$http.get(`/admin/users/${this.currentUser.id}/diets`)
        .then(response => {
          this.diets = this.keysToCamelCase(response.data).concat(this.diets)
        })
        .catch(err => { console.log(err) })
      this.$http.get('/admin/diets')
        .then(response => {
          const filtered = this.keysToCamelCase(response.data)
            .filter(diet => diet.dietType === 'Veřejný' || diet.dietType === 'Stálá nabídka')
          this.diets = filtered.concat(this.diets)
        })
        .catch(err => console.log(err))
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
            .filter(type => type.active)
          this.getOrders()
        })
      this.getTransactions()
    },
    getOrders () {
      this.loading = true
      this.serverError = false
      this.historyOrders = []
      this.upcomingOrders = []
      this.$http.get(`/users/${this.currentUser.id}`)
        .then(response => {
          this.updateCredit(response.data.credit)
        })

      this.editDialog = false
      this.$http.get('/orders')
        .then(response => {
          const orders = this.keysToCamelCase(response.data.orders)
          orders.forEach(order => {
            const count = order.boarders.length + !!order.order
            // platba
            switch (order.paymentTypeId) {
              case 1: order.paymentType = 'Kredit/Dluh'; break
              case 3: order.paymentType = 'Hotově/Kartou při převzetí'; break
              case 4: order.paymentType = 'Bankovním převodem'; break
              case 5: order.paymentType = 'Kartou online'; break
            }

            order.orderDays.forEach(day => {
              function mapItem (item, count) {
                return {
                  ...item.eatable,
                  alergensStr: item.eatable.alergens.map(alergen => alergen.name).join(', '),
                  quantity: item.quantity,
                  type: item.type,
                  timeId: item.timeId,
                  totalQuantity: item.quantity * count
                }
              }

              const editable = day.orderItems.filter(item => item.editable && item.driversId === null).map(item => mapItem(item, count))
              const notEditable = day.orderItems.filter(item => !item.editable || item.driversId !== null).map(item => mapItem(item, count))
              const notEditable6Arrs = [[], [], [], [], [], []]
              const editable6Arrs = [[], [], [], [], [], []]
              const prices = [day.time1Price, day.time2Price, day.time3Price, day.time4Price, day.time5Price, day.time6Price]
              const baseObject = {
                subId: order.id + Math.random(),
                date: day.date,
                customPackaging: order.customPackaging,
                deliveryType: order.deliveryType,
                boarders: order.boarders,
                order: order.order,
                user: order.user,
                paymentType: order.paymentType,
                orderId: order.id,
                state: order.state,
                dayPrice: day.totalPrice,
                ...order,
                packagingPrice: order.customPackaging === 1 ? 0 : order.packagingPrice
              }

              this.timeTypes.forEach(time => {
                editable6Arrs[time.id - 1] = editable.filter(item => item.timeId === time.id)
                notEditable6Arrs[time.id - 1] = notEditable.filter(item => item.timeId === time.id)
              })

              if (notEditable.length) {
                const dayPrice = prices
                  .filter((price, index) => !!notEditable6Arrs[index].length)
                  .reduce((prev, next) => prev + next, 0)
                this.historyOrders.push({
                  ...baseObject,
                  items: notEditable6Arrs,
                  dayPrice
                })
              }

              if (editable.length) {
                const dayPrice = prices
                  .filter((price, index) => !!editable6Arrs[index].length)
                  .reduce((prev, next) => prev + next, 0)

                this.upcomingOrders.push({
                  ...baseObject,
                  items: editable6Arrs,
                  dayPrice
                })
              }
            })
            this.upcomingOrders.sort((a, b) => b.orderId - a.orderId).sort((a, b) => b.date < a.date)
            this.historyOrders.sort((a, b) => {
              if (a.orderId !== b.orderId) {
                return b.orderId - a.orderId
              }

              return (new Date(b.date)).getTime() - (new Date(a.date)).getTime()
            })
          })
          // this.historyOrders.forEach(item => {
          //   if ((item.date >= new Date().toISOString().split('T')[0]) && item.state === 'Čekající') {
          //     this.upcomingOrders.push(item)
          //     console.log(item)
          //   }
          // })
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.serverError = true
        }).finally(() => {
          console.log(this.upcomingOrders)
        }
        )
    },
    payOrder (id) {
      this.$http.post('orders/pay', {
        order_id: id
      })
        .then(res => {
          window.location.replace(res.data)
        })
    },
    getTransactions () {
      this.$http.get('/transactions')
        .then(response => {
          this.transactions = this.keysToCamelCase(response.data)
            .map(transaction => {
              const tmp = new Date(transaction.createdAt)
              transaction.date = `${tmp.getDate()}.${tmp.getMonth() + 1}. ${tmp.getFullYear()}`
              switch (transaction.paymentTypeId) {
                case 1: transaction.type = 'Platba kreditem'; break
                case 3: transaction.type = 'Platba při převzetí'; break
                case 4: transaction.type = 'Platba bankovním převodem'; break
                case 5: transaction.type = 'Platba kartou'; break
                case 6: transaction.type = 'Dobití kreditu'; break
                case 7: transaction.type = 'Připsání kreditu'; break
                case 8: transaction.type = 'Vrácení kreditu'; break
                case 9: transaction.type = 'Dobropis'; break
              }
              return transaction
            })
            .reverse()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    getLocalizedDate (dateStr) {
      const date = new Date(dateStr)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    getLocalizedWeekDay (dateStr) {
      const date = new Date(dateStr)
      const localeDayStr = date.toLocaleDateString('cs-cz', { weekday: 'long' })
      return localeDayStr[0].toUpperCase() + localeDayStr.slice(1)
    },
    getSelectedTimesStr (date, itemsArr) {
      let timeNames = []
      if (this.timeTypes.length) {
        timeNames = [0, 1, 2, 3, 4, 5]
          .map(time => this.timeTypes[time].name)
      }
      return timeNames
        .filter((time, index) => itemsArr[index].length)
        .join(', ')
    },
    editOrder (order) {
      const dietIndex = this.diets
        .map(diet => diet.id)
        .indexOf(order.dietId)
      order.diet = this.diets[dietIndex]
      this.editedItem = {
        id: order.id,
        price: order.dayPrice,
        shoppingCart: {
          ...order,
          diet: {},
          customPackaging: !!order.customPackaging,
          boarders: order.boarders.map(boarder => {
            boarder.fullName = `${boarder.firstName} ${boarder.lastName}`
            return boarder
          }),
          user: this.currentUser,
          items: {
            [order.date]: order.items
          }
        },
        dates: [order.date]
      }
      this.editDialog = true
    },
    deleteOrder (id, date, order) {
      if (confirm(`Opravdu si přejete smazat objednávku č. ${id} na ${date.split('-').reverse().join('. ')}?`)) {
        this.$http.post('/orders/delete-day', this.keysToSnakeCase({
          date,
          order
        }))
          .then(() => {
            this.getOrders()
            this.getTransactions()
          })
          .catch(() => {
            this.deleteError = true
            setTimeout(() => { this.deleteError = false }, 3500)
            this.getOrders()
            this.getTransactions()
          })
      }
    },
    showInvoice (item) {
      this.$http({
        method: 'POST',
        url: '/invoices/download',
        responseType: 'blob',
        data: {
          invoice_id: item.invoice.id
        }
      })
        .then(response => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' })
          const fileURL = URL.createObjectURL(file)
          window.open(fileURL)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPaymentTypeColor (id) {
      if ((id >= 1 && id <= 5) || id === 9) {
        return 'payment-type-red'
      } else {
        return 'payment-type-green'
      }
    },
    ...mapMutations({ updateCredit: 'user/updateCredit' })
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>
.cart-heading{
  width: 15vw;
  text-align: center;
}
.v-window-item, .v-window-item--active{
  text-align: center;
}
.v-item-group{
  text-align: left;
}
.payment-type-green {
  color: #4caf50;
}
.payment-type-green:before{
  content: '+';
}
.payment-type-red {
  color: #ff5252;
}
.payment-type-red:before{
  content: "-";
}
.v-tab{
  font-family: 'Poppins', sans-serif !important;
}
.v-data-table{
  border-radius: 10px;
  border: 1px solid #979797;
}
>>>.v-tabs-bar{
  margin-bottom: 20px !important;
}
</style>
